import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { addSupportChatModuleTagAPI } from '../../../api/supportChatModuleTags';
import SupportWidgetKeys from '../../SupportWidget/queryKeys';

const { getTagsList } = SupportWidgetKeys;

const useCreateSupportChatModuleTagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    data => {
      const { name, description, isActive } = data;
      return addSupportChatModuleTagAPI({ name, description, isActive });
    },
    {
      onSuccess: () => {
        // Invalidate both the management table query and the filter query
        queryClient.invalidateQueries(['supportChatModuleTags']);
        queryClient.invalidateQueries([getTagsList]);
        message.success('Tag created successfully');
      },
      onError: error => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Failed to create tag';
        message.error(errorMessage);
      },
    }
  );
};

export default useCreateSupportChatModuleTagMutation;
